// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useMemo } from 'react';

import { RadioButtonChecked, RadioButtonUnChecked } from '../Svg/Icons/RadioButton';
import classes from './SelectBox.scss';

interface ISelectBox {
  domId: string;
  text: string;
  style?: React.CSSProperties;
  checked: boolean;
  onChange: (checked: boolean, domId: string) => void;
  className?: string;
}

const SelectBox: React.FC<ISelectBox> = ({ domId, text, style, checked, onChange, className }) => {
  const handleCheckboxOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked, event.target.name);
  };

  const svg = checked ? <RadioButtonChecked size="1.25rem" fill="var(--primary-color)" className={classes.checked} /> : <RadioButtonUnChecked size="1.25rem" fill="var(--text-primary-color)" className={className} />;

  const memoizedUniqueDomId = useMemo(() => `checkbox${Math.random()}`, []);

  const styles = [classes.checkbox];
  if (checked) styles.push(classes.checked);

  return (
    <label className={styles.join(' ')} htmlFor={memoizedUniqueDomId} style={style}>
      <span className={classes.span1}>
        <input id={memoizedUniqueDomId} name={domId} type="checkbox" checked={checked} onChange={handleCheckboxOnChange} />
        {svg}
      </span>
      <span className={classes.span2}>{text}</span>
    </label>
  );
};

export default SelectBox;
